import { useChatbotStore, useChatStateStore, useMessagesStore, useProductsStore, useUserStore, useToastStore } from "../zustand/store";
import { ChatBubble, ChatStreamingBubble, GreetingBubble, LoadingBubble, TailBubble } from "./ChatBubble";
import { useEffect, useRef, useState } from 'react';
// import PreQuestion from "./PreQuestion";
import { CollectionForm, CompletedForm } from "./Form";
import Toast from "./Toast";
import PreQuestionRefactored from "./PreQuestion/PreQuestionRefactored";

const Chat = () => {
    const { messages } = useMessagesStore();
    const { chatbot } = useChatbotStore();
    const { partnerType } = useUserStore();
    const { followupQuestion } = useProductsStore();
    const {
        isChatbotPending,
        isPreAnswered,
        isFormSubmitted,
        setIsFormSubmitted,
        isStreaming,
        displayLocation,
        isLastIntentProductRecommendation
    } = useChatStateStore();
    const { isToastVisible } = useToastStore();
    const chatContainerRef = useRef(null);
    const [isTailVisible, setIsTailVisible] = useState(false);
    const [isAutoScrolling, setIsAutoScrolling] = useState(true);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;

            // overscroll prevention (even when content height is less than container height)
            chatContainerRef.current.addEventListener('wheel', (e) => {
                const atTop = chatContainerRef.current.scrollTop === 0;
                const atBottom = chatContainerRef.current.scrollHeight - chatContainerRef.current.scrollTop === chatContainerRef.current.clientHeight;

                const scrollingUp = e.deltaY < 0;
                const scrollingDown = e.deltaY > 0;

                const prevent =
                    (atTop && scrollingUp) || (atBottom && scrollingDown);

                if (prevent) {
                    e.preventDefault();
                }
            }, { passive: false })

            let startY = 0;

            chatContainerRef.current.addEventListener('touchstart', (e) => {
                startY = e.touches[0].clientY;
            }, { passive: true });

            chatContainerRef.current.addEventListener('touchmove', (e) => {
                const currentY = e.touches[0].clientY;
                const deltaY = currentY - startY;

                const atTop = chatContainerRef.current.scrollTop === 0;
                const atBottom = chatContainerRef.current.scrollHeight - chatContainerRef.current.scrollTop === chatContainerRef.current.clientHeight;

                const scrollingUp = deltaY > 0;
                const scrollingDown = deltaY < 0;

                const prevent =
                    (atTop && scrollingUp) || (atBottom && scrollingDown);

                if (prevent) {
                    e.preventDefault();
                }
            }, { passive: false });
        }
    }, [messages, chatbot?.preQuestion, isTailVisible, isFormSubmitted, followupQuestion]);

    useEffect(() => {
        const fastfiveCondition = (partnerType === 'fastfive') && messages.length > 0 && !isChatbotPending && isPreAnswered && isFormSubmitted !== 'submitted';
        const otherCondition = messages.length > 0 && !isChatbotPending && !isStreaming;
        const condition = partnerType === 'fastfive' ? fastfiveCondition : otherCondition;

        if (condition) {
            setIsTailVisible(true);
        } else {
            setIsTailVisible(false);
        }
    }, [followupQuestion, messages, isChatbotPending, isPreAnswered, isStreaming, isFormSubmitted]);

    useEffect(() => {
        if (isStreaming && !isChatbotPending) {
            setIsAutoScrolling(true);
        }
    }, [isStreaming, isChatbotPending]);


    useEffect(() => {
        if (!chatContainerRef.current) return;
        const currentChatContainerRef = chatContainerRef.current;

        const handleWheel = (e) => {
            if (isAutoScrolling) {
                setIsAutoScrolling(false);
            }
        };

        const handleTouchMove = (e) => {
            if (isAutoScrolling) {
                setIsAutoScrolling(false);
            }
        };

        if (isStreaming && !isChatbotPending && isAutoScrolling) {
            chatContainerRef.current.addEventListener('wheel', handleWheel, { passive: false });
            chatContainerRef.current.addEventListener('touchmove', handleTouchMove, { passive: false });
        }

        return () => {
            if (currentChatContainerRef) {
                currentChatContainerRef.removeEventListener('wheel', handleWheel, { passive: false });
                currentChatContainerRef.removeEventListener('touchmove', handleTouchMove, { passive: false });
            }
        };
    }, [isStreaming, isChatbotPending, isAutoScrolling]);

    useEffect(() => {
        if (chatbot.preQuestion.questions.length > 0) {
            if (!isPreAnswered) return;
        }
        if (partnerType === 'fastfive') {
            if (!isLastIntentProductRecommendation) return;
        }
        if (partnerType !== 'fastfive' && !chatbot.experimentalData?.some(data => data.key === 'csInquiry')) return;
        if (messages.length > 0
            && isTailVisible
            && followupQuestion.length > 0) {
            setTimeout(() => {
                setIsFormSubmitted('ready');
            }, 2000);
        }
        
    }, [isTailVisible, followupQuestion, isLastIntentProductRecommendation, partnerType]);

    return (
        <div
            ref={chatContainerRef}
            style={{ width: '100%', flex: 1, position: 'relative', overflow: 'scroll', padding: '8px 0', overscrollBehavior: 'contain' }}
        >
            {
                messages.length === 0 && !isChatbotPending && displayLocation !== 'PRODUCT_DETAIL' &&
                <GreetingBubble />
            }
            {
                messages.length === 0 && !isChatbotPending && displayLocation === 'PRODUCT_DETAIL' &&
                <LoadingBubble />
            }
            {
                messages.length > 0 &&
                messages?.map((message, index) => (
                    message.type === 'form' ?
                        <CompletedForm
                            formData={message.message}
                            chatContainerRef={chatContainerRef}
                        /> :
                        <ChatBubble key={index} message={message}
                        />
                ))
            }
            {
                isStreaming && !isChatbotPending &&
                <ChatStreamingBubble
                    chatContainerRef={chatContainerRef}
                    isAutoScrolling={isAutoScrolling}
                />
            }
            {
                isChatbotPending &&
                <LoadingBubble />
            }
            {
                Object.keys(chatbot.preQuestion.questions).length !== 0 &&
                <PreQuestionRefactored />
            }
            {/* {
                partnerType !== 'fastfive' && messages.length === 0 &&
                <GuideButtonGroup />
            } */}
            {
                isTailVisible &&
                <TailBubble message={followupQuestion} />
            }
            {
                isFormSubmitted === 'ready' &&
                <CollectionForm
                    chatContainerRef={chatContainerRef}
                />
            }
            <Toast />
        </div>
    )
}

export default Chat;